import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { i18n } from '../../translate/i18n';
import * as actions from '../../store/actions';

import {
  Container,
  Button,
  CssBaseline,
  TextField,
  Grid,
  CircularProgress,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import {
  LogoText,
  Appbar,
} from './styles';
import Email from "@mui/icons-material/EmailOutlined";
import Recaptcha from 'react-recaptcha';
import { formatLanguageFromLocalStorage } from '../../utils/formatLanguageFromLocalStorage';
import { emailValidator } from '../../utils/emailValidator';

const useStyles = makeStyles(theme => ({
  '@global': {
    body: {
      backgroundColor: theme.palette.common.white,
    },
  },
  paper: {
    marginTop: 150,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    backgroundColor: "green",
    '&:hover': {
      backgroundColor: "green",
      opacity: .90,
    },
  },
}));

let recaptchaInstance;

export default function ForgotPassword() {
  const dispatch = useDispatch();
  const classes = useStyles();

  const [email, setEmail] = useState("");

  const [linkSent, setLinkSent] = useState(false);
  const [emailError, setEmailError] = useState(false);

  const [verified, setVerified] = useState(false);
  const [captcha, setCaptcha] = useState("");

  const forgotPassword = (body) => dispatch(actions.forgotPassword(body))

  const loadingUser = useSelector(state => state.users.loading);


  useEffect(() => {
    resetRecaptcha()
  }, [])

  const handleSubmit = (e) => {
    e.preventDefault();
    let hasError = false;

    if (!emailValidator(email)) {
      setEmailError(true)
      hasError = true;
    }

    if (hasError) return;

    let localStorageLang = localStorage.getItem("i18nextLng");
    let emailLanguage = formatLanguageFromLocalStorage(localStorageLang);

    let body = {
      email,
      captcha,
      emailLanguage,
    }


    forgotPassword(body).then((response) => {
      if (response === 'success') {
        setLinkSent(true);
      } else {
        resetRecaptcha()
      }
    })

  }

  const verifyCallback = response => {
    if(response) {
        setVerified(true);
        setCaptcha(response)
    } else {
        setVerified(false);
        setCaptcha("")
    }
  }

  const onloadCallback = () => {
  }

  // create a reset function
  const resetRecaptcha = () => {
    recaptchaInstance.reset();
  };

  return (
    <>
      <Appbar />
      <Container component="main" maxWidth="xs" style={{ marginBottom: '100px' }}>
        <CssBaseline />
        {!linkSent && (
          <div className={classes.paper}>
            <LogoText />
            <form className={classes.form} noValidate onSubmit={handleSubmit}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    required
                    fullWidth
                    id="email"
                    label={i18n.t('textFieldForgotPassword.email')}
                    name="email"
                    autoComplete="email"
                    value={email}
                    error={emailError}
                    onChange={event => setEmail(event.target.value.toLowerCase())}
                  />
                </Grid>
              </Grid>
              <div style={{ marginTop: "20px" }}>
                <Recaptcha
                  sitekey="6LeuVO4UAAAAADQBMGsGI-YQEjhSd9q3XQ-HLeGj"
                  render="explicit"
                  verifyCallback={verifyCallback}
                  expiredCallback={verifyCallback}
                  onloadCallback={onloadCallback}
                  ref={e => recaptchaInstance = e}
                />
              </div>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
                disabled={loadingUser || !verified}
                startIcon={loadingUser && <CircularProgress />}
              >
                {i18n.t('btnForgotPassword.text')}
          </Button>

            </form>
          </div>)}
        {linkSent && (
          <div className={classes.paper}>

            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: "100%", height: "100%" }}>
              <Email style={{ height: "100px", width: "100px", color: "gray" }} />
              <div style={{ fontSize: "25px", fontWeight: 'bold', textAlign: "center" }}>{i18n.t('divForgotPassword.text')}</div>
              <div style={{ fontSize: "15px", color: "#333", minWidth: "450px", marginTop: "30px", textAlign: "center" }}>{i18n.t('divForgotPassword.text1')} <b>{email}</b></div>
            </div>
          </div>
        )}
      </Container>
    </>
  );
}
